import React from "react";
import { useSelector, useDispatch } from "react-redux";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
// import gift_box from "../../../../assets/images/gift_box.png";
import payment_success from "../../../../assets/svgs/check_mark.svg";
import payment_failed from "../../../../assets/svgs/payment_failed.svg";
import Button from "../../Button/Button";
import { coinPaymentModalStyles as styles } from "./coinsPaymentModalStatusModalStyles.tailwind.js";
import { PAYMENT_STATUS } from "../../../../lib/constants/globalConstant";
import { getMyCart } from "../../../../redux/slices/cartSlice.js";
import { useNavigate } from "react-router-dom";
import routeConstant from "../../../../lib/constants/routeConstant.js";

const CoinPaymentStatusModal = ({
    isOpen,
    onClose,
    status,
    heading,
    subHeading,
    message
}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { currentSeason } = useSelector(state => state.seasons);
    const { checkoutCoinsApiData } = useSelector((state) => state.cart);

    const successData = {
        Heading: "Thank you",
        Message: `Your payment has been successfully completed. Enjoy the game and have an amazing experience!`,
        image: payment_success
    };

    const errorData = {
        Heading: "Purchase Failed!",
        SubHeading: "Something went wrong",
        Message: "Your token purchase was not completed. Please try again.",
        image: payment_failed
    };

    const data = status === PAYMENT_STATUS.SUCCEDED ? successData : errorData;

    const handleOnClose = () => {
        onClose();
        const seasonId = currentSeason?._id;

        if (status === PAYMENT_STATUS.SUCCEDED) {
            if (seasonId) dispatch(getMyCart({ seasonId }));
            navigate(routeConstant.MY_ACCOUNT_PAGE);
        } else {
            if (seasonId) dispatch(getMyCart({ seasonId }));
            navigate(routeConstant.CART_PAGE);
        }
    };

    return (
        <Modal
            open={isOpen}
            onClose={onClose}
            disableAutoFocus
        >
            <div className={styles.container}>
                {/* curved header banner */}
                <div className={styles.banner}>
                    {/* close button */}
                    <button onClick={handleOnClose} className={styles.closeButton}>
                        <CloseIcon />
                    </button>
                    {/* floating image */}
                    <div className={styles.imageContainer}>
                        <div className={status === PAYMENT_STATUS.SUCCEDED ? styles.doneIcon : ""}>
                            <img src={data.image} alt="Payment Status" className={status === PAYMENT_STATUS.SUCCEDED ? styles.successImage : styles.image} />
                        </div>
                    </div>
                </div>

                {/* main-content */}
                <div className={styles.innerContainer}>
                    {/* texts */}
                    <div className={status === PAYMENT_STATUS.SUCCEDED ? styles.heading : styles.errorHeading}>
                        {heading || data.Heading}
                    </div>



                    <div className={styles.message}>
                        {message || data.Message}
                    </div>

                    <div className="w-full mt-2 flex justify-center">
                        <Button
                            variant="primary"
                            onClick={handleOnClose}
                            className={styles.button}
                        >
                            {status === PAYMENT_STATUS.SUCCEDED ? "Close" : "Retry"}
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default CoinPaymentStatusModal;
